import verificaSeParcelaAtrasada from '../../../Utils/checkIfBillIsLate';
import { tiposParcela } from './tiposParcelas';

const totalParcelasSelecionadas = (parcelasSelecionadas) => {
  let total = 0;

  parcelasSelecionadas.forEach((parcela) => {
    total += parseFloat(parcela.parcela.valorReajustado);
  });

  return total;
};

const handleTipoParcelas = (parcelasSelecionadas) => {
  const atrasada = verificaSeParcelaAtrasada(
    parcelasSelecionadas[0]?.parcela?.dataVencimento
  );

  if (parcelasSelecionadas?.length === 1) {
    return atrasada
      ? tiposParcela.simplesComAtraso
      : tiposParcela.simplesSemAtraso;
  }

  if (parcelasSelecionadas?.length > 1) {
    return !atrasada ? tiposParcela.agrupadas : tiposParcela.agrupadasComAtraso;
  }
};

const verifyIfParcelHasCompanyDifferent = (parcelasSelecionadas) => {
  const firstCompany = parcelasSelecionadas[0].parcela.empresa;

  return !parcelasSelecionadas.every((i) => i.parcela.empresa === firstCompany);
};

export {
  totalParcelasSelecionadas,
  handleTipoParcelas,
  verifyIfParcelHasCompanyDifferent,
};
